import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import unknown from '../../images/dummyPhoto/user-circle-fill.png';

const UserImage = styled.img`
  widht: ${props => `${props.size}px`};
  height: ${props => `${props.size}px`};
  borderradius: 50%;
  margin: 0 8px 0 0;
`;

const UserIcon = ({ url, size }) => (
  <UserImage size={size} src={url || unknown} alt="user-icon" />
);

UserIcon.propTypes = {
  url: PropTypes.string,
  size: PropTypes.number,
};
UserIcon.defaultProps = {
  url: '',
  size: 25,
};

export default UserIcon;
